class HbsVezneTanimDTO {
    id?: number = null;
    adi?: string = "";
    organizasyonId?: number = null;
    eklemeKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    seriNo?: string = "";
    kalinanNo?: number = null;
    fkVeznePoscihaztanim?: number = null;
    oncekiKasaKapamaUyari?: number = 1;

    //Arama Kriterleri
    multiOrganizasyon?: string = null;
}
export default HbsVezneTanimDTO;